import css from "styled-jsx/css";

export const componentStyles = css`
  .template-feature-content {
    width: 100%;
    max-width: 720px;

    .demo-component-wrapper {
      margin-top: 48px;
    }
  }
`;
